import ManageBookingApiClient from '../../../api/clients/ManageBookingApiClient';
import { PACKAGE_TYPE } from '../../../utilities/constants';
import { getErrorMessage } from '../../../utilities/messageUtils';
import reservationDetailsActionTypes from '../ReservationDetailsEntity/reservationDetailsEntity.types';
import manageReservationTypes from './manageReservation.types';

export const getManageReservationDetails = reservationId => async dispatch => {
  dispatch({ type: manageReservationTypes.GET_MANAGERESERVATIONDETAILS_REQUEST });

  try {
    const manageBookingApiClient = new ManageBookingApiClient();
    const manageBookingResponse = await manageBookingApiClient.manageBooking(reservationId, { includeNor1: true });
    dispatch({
      type: manageReservationTypes.GET_MANAGERESERVATIONDETAILS_SUCCESS,
      response: manageBookingResponse?.data
    });
  } catch (err) {
    dispatch({
      type: manageReservationTypes.GET_MANAGERESERVATIONDETAILS_FAILURE,
      message: getErrorMessage(err.message)
    });
  }
};

export const getReservationDetailsByReservationIdAndReservationKey = (
  reservationId,
  reservationkey
) => async dispatch => {
  try {
    dispatch({ type: manageReservationTypes.GET_MANAGERESERVATIONDETAILS_REQUEST });

    const manageBookingAPI = new ManageBookingApiClient();
    const response = await manageBookingAPI.loginReservationsByIdAndReservationKey(reservationId, reservationkey);

    if (!response.data) {
      throw new Error();
    }

    dispatch({
      type: manageReservationTypes.GET_RESERVATION_BY_ID_AND_LAST_NAME_SUCCESS,
      response: response?.data
    });

    let updateBookingInfo;
    if (response) {
      updateBookingInfo = await manageBookingAPI.manageBooking(reservationId, { includeNor1: true });
    }

    dispatch({
      type: manageReservationTypes.GET_MANAGERESERVATIONDETAILS_SUCCESS,
      response: updateBookingInfo.data
    });
  } catch (error) {
    dispatch({
      type: manageReservationTypes.GET_MANAGERESERVATIONDETAILS_FAILURE,
      message: getErrorMessage(error.message)
    });
  }
};

export const clearManageReservationDetails = () => ({
  type: manageReservationTypes.CLEAR_MANAGERESERVATIONDETAILS
});

export const fetchAddOns = (reservationId, showCMPSpinner = true) => async dispatch => {
  if (showCMPSpinner) {
    dispatch({ type: manageReservationTypes.FETCH_RESERVATION_ADD_ONS_REQUEST });
  }

  try {
    const apiClient = new ManageBookingApiClient('v2');
    let response = await apiClient.getReservationAddOnsById(reservationId);

    // MAPPING INSIDE mappedData NEEDS TO BE DEPRECATED
    // WHEN REFACTORED ALL COMPONENTS THE UPSELL ADDONS DATA REACHES
    // WITH NEW API STRUCTURE AND MATCHING TYPES

    const mappedData = response?.data?.cards.map(card => {
      const NEW_TO_OLD_PACKAGE_TYPE = {
        cabana: PACKAGE_TYPE.cabanasAndFlexTrip,
        'late-checkout': PACKAGE_TYPE.lateCheckOut,
        parking: PACKAGE_TYPE.family
      };

      const type = card.type.toLowerCase();

      return {
        ...card,
        type: NEW_TO_OLD_PACKAGE_TYPE[type] || PACKAGE_TYPE[type]
      };
    });

    dispatch({
      type: manageReservationTypes.FETCH_RESERVATION_ADD_ONS_SUCCESS,
      response: mappedData
    });

    const dynamicTileObject = response?.data?.dynamicTile;

    dispatch({
      type: reservationDetailsActionTypes.FETCH_RESERVATION_DYNAMIC_TILE_SUCCESS,
      response: dynamicTileObject
    });
  } catch (err) {
    dispatch({
      type: manageReservationTypes.FETCH_RESERVATION_ADD_ONS_FAILURE,
      message: getErrorMessage(err.message)
    });
  }
};

export const getComparisonChanges = (reservationId, requestPayload) => async dispatch => {
  dispatch({ type: manageReservationTypes.GET_COMPARISON_CHANGES_REQUEST });
  try {
    const manageBookingApiClient = new ManageBookingApiClient();
    const manageBookingResponse = await manageBookingApiClient.getComparisonChanges(reservationId, requestPayload);
    dispatch({
      type: manageReservationTypes.GET_COMPARISON_CHANGES_SUCCESS,
      response: manageBookingResponse?.data
    });
  } catch (err) {
    dispatch({
      type: manageReservationTypes.GET_COMPARISON_CHANGES_FAILURE,
      message: getErrorMessage(err.message)
    });
  }
};

export const updateAddGuestsReservation = (reservationId, requestObj) => dispatch => {
  const manageBookingAPI = new ManageBookingApiClient();
  const request = manageBookingAPI.updateAddGuestsModal(reservationId, requestObj);

  return request.then(
    response => {
      dispatch({
        type: manageReservationTypes.UPDATE_RESERVATION_DETAILS_NEW_GUESTS_RESERVATION_SUCCESS,
        response: response.data
      });
    },
    err => {
      dispatch({
        type: manageReservationTypes.UPDATE_RESERVATION_DETAILS_NEW_GUESTS_RESERVATION_ERROR,
        message: getErrorMessage(err.message)
      });
    }
  );
};

export const clearAddGuestsReservation = () => dispatch => {
  dispatch({
    type: manageReservationTypes.UPDATE_RESERVATION_DETAILS_NEW_GUESTS_RESERVATION_CLEAR
  });
  dispatch({
    type: manageReservationTypes.UPDATE_RESERVATION_DETAILS_NEW_GUESTS_RESERVATION_ERROR_CLEAR
  });
};

export const cleanComparisonChanges = () => ({
  type: manageReservationTypes.GET_COMPARISON_CHANGES_CLEAN
});

export const updateReservationCheckIn = reservationId => async dispatch => {
  dispatch({ type: manageReservationTypes.FETCH_MANAGE_RESERVATION_REQUEST });

  try {
    const apiClient = new ManageBookingApiClient();
    const response = await apiClient.getReservationCheckIn(reservationId);

    dispatch({
      type: manageReservationTypes.FETCH_MANAGE_RESERVATION_CHECK_IN_VALUE_SUCCESS,
      response: response.data
    });
  } catch (err) {
    dispatch({
      type: manageReservationTypes.FETCH_MANAGE_RESERVATION_FAILURE,
      message: getErrorMessage(err.message)
    });
  }
};
